export const AWS_CAPTCHA_CONTAINER_ID = 'aws-captcha-container';

export const AWS_CAPTCHA_SCRIPT_ID = 'aws-captcha-jsapi';

/**
 * Maximum number of failed AWS CAPTCHA validations before ending an authentication flow.
 * This prevents a persistent WAF 405 response from trapping the user in a challenge loop.
 */
export const MAX_AWS_CAPTCHA_FAILURES = 5;
